import React, { useEffect, useRef, useState } from "react";
import { HiChatAlt2 } from "react-icons/hi";
import { MdOutlineSend } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";

export default function ChatComponent({
  onClose,
  title,
  heightClass = "h-[500px]",
  isVisible = true,
  messages = [],
  onSend,
  customer_img,
  orderId,
}) {
  const [input, setInput] = useState("");
  const bottomRef = useRef(null);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current && messages.length > 0) {
      // first load → scroll
      bottomRef.current?.scrollIntoView({ behavior: "auto" });
      isFirstLoad.current = false;
    }
  }, [messages]);

  const handleSend = () => {
    if (input.trim() !== "") {
      onSend(input.trim());
      setInput("");
      setTimeout(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  };

  return (
    <div
      className={`flex flex-col w-full rounded-xl shadow bg-white overflow-hidden ${heightClass}`}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-3 border-b bg-gradient-to-r from-[#f2f4f7] to-[#e6ebf1]">
        <div className="flex items-center gap-3 text-[#3383B2] font-semibold text-base md:text-lg">
          {/* Customer Image or Fallback Icon */}
          {customer_img ? (
            <img
              src={customer_img}
              alt={title}
              className="w-10 h-10 rounded-full object-cover border-2 border-[#3383B2] shadow-sm"
              onError={(e) => {
                e.target.style.display = 'none'; // Hide broken image
                e.target.nextSibling.style.display = 'block'; // Show fallback icon
              }}
            />
          ) : (
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F2F9FF] text-[#3383B2] shadow-sm">
              <HiChatAlt2 className="text-xl" />
            </div>
          )}

          <div className="flex flex-col">
    <span className="truncate max-w-[180px] md:max-w-none leading-tight">
      {title}
    </span>
    {orderId && (
      <span className="text-xs md:text-sm font-medium text-gray-500 leading-tight">
        {orderId}
      </span>
    )}
  </div>
        </div>

        {isVisible && (
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-xl"
          >
            ×
          </button>
        )}
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-[#fafafa]">
        {messages?.map((msg, idx) => (
          <div
            key={idx}
            className={`flex flex-col items-${msg.sender === "sender" ? "end" : "start"
              }`}
          >
            {msg?.relatedMismatch ? (
              <div
                className={`flex items-end ${msg?.sender === "sender" ? "justify-end" : "justify-start"
                  }`}
              >
                {msg?.sender !== "sender" && (
                  <FaUserCircle className="text-2xl text-gray-500 mr-2" />
                )}


                <div
                  className={`w-full max-w-[80%] rounded-xl p-3 shadow border space-y-2 
      ${msg?.sender === "sender"
                      ? "bg-[#3383B2] text-white"
                      : "bg-white border-gray-200"
                    }`}
                >
                  <div
                    className={`font-medium  text-sm ${msg?.sender === "sender" ? "text-white" : "text-gray-800"
                      }`}
                  >
                    {msg?.text}
                  </div>
                  <div
                    className={`font-medium  text-xs ${msg?.sender === "sender" ? "text-white" : "text-gray-800"
                      }`}
                  >
                    note:{msg?.relatedMismatch?.message}
                  </div>
                  {msg.senderRole === 'store' && (
                    <div className="flex items-start gap-3">
                      {msg?.relatedMismatch?.imageUrl && (
                        <img
                          src={msg?.relatedMismatch?.imageUrl}
                          alt="Mismatch"
                          className="w-16 h-16 rounded-md object-cover border"
                        />
                      )}
                      <div className="flex-1 flex flex-col gap-1">
                        <div className="flex flex-wrap gap-1 text-[11px] text-gray-600">
                          <span className="bg-gray-100 px-2 py-0.5 rounded-full">
                            Expected: <b>{msg?.relatedMismatch?.expectedValue}</b>
                          </span>
                          <span className="bg-gray-100 px-2 py-0.5 rounded-full">
                            Actual: <b>{msg?.relatedMismatch?.actualValue}</b>
                          </span>
                          <span className="bg-gray-100 px-2 py-0.5 rounded-full">
                            Charge:{" "}
                            <b>${msg?.relatedMismatch?.additionalCharge}</b>
                          </span>
                        </div>
                        {msg?.chatType === "customer" && (
                          <div className="flex gap-2 mt-2">
                           {msg?.relatedMismatch?.decision !== "accepted" && (<button
                              className="flex-1 px-2 py-1 text-xs font-semibold rounded-full 
                bg-gradient-to-r from-green-400 to-green-600 text-white shadow 
                hover:from-green-500 hover:to-green-700 transition duration-200"
                              onClick={() =>
                                msg.onDecision?.("accept", msg.relatedMismatch)
                              }
                            >
                              Pay Now 
                            </button>)}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <div
                    className={`text-[10px] text-right ${msg?.sender === "sender" ? "text-white" : "text-gray-400"
                      }`}
                  >
                    {msg?.time}
                  </div>
                </div>

                {msg?.sender === "sender" && (
                  <FaUserCircle className="text-2xl text-gray-500 ml-2" />
                )}
              </div>
            ) : (
              <div
                className={`flex items-end ${msg?.sender === "sender" ? "justify-end" : "justify-start"
                  }`}
              >
                {msg?.sender !== "sender" && (
                  <FaUserCircle className="text-2xl text-gray-500 mr-2" />
                )}
                <div
                  className={`max-w-[80%] rounded-lg px-3 py-2 text-sm shadow break-words
            ${msg?.sender === "sender"
                      ? "bg-[#3383B2] text-white"
                      : "bg-white text-gray-800"
                    }`}
                >
                  {msg?.text}
                  <div
                    className={`text-[10px] text-right mt-1 text-gray-400
                     ${msg?.sender === "sender"
                        ? " text-white"
                        : "text-gray-400"
                      }`}
                  >
                    {msg?.time}
                  </div>
                </div>
                {msg?.sender === "sender" && (
                  <FaUserCircle className="text-2xl text-gray-500 ml-2" />
                )}
              </div>
            )}
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div className="flex items-center p-2 border-t bg-white">
        <input
          type="text"
          placeholder="Type your message..."
          className="flex-1 rounded-full px-4 py-2 border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-[#3383B2]"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button
          className="ml-2 bg-gradient-to-r from-[#3383B2] to-[#28709A] text-white rounded-full p-2 hover:opacity-90"
          onClick={handleSend}
        >
          <MdOutlineSend className="text-lg" />
        </button>
      </div>
    </div>
  );
}
